module.exports = __webpack_public_path__ + "static/media/iab-verified-logo.01dec01e.png";